































































































import DictMixin from '@/mixins/dict-mixin';
import MenuMixin from '@/mixins/menu-mixin';
import ParamsServices, { ParamsDto } from '@/services/params';
import { mixins } from 'vue-class-component';
import { Component, Watch } from 'vue-property-decorator';
@Component
export default class DictDetail extends mixins(DictMixin, MenuMixin) {
  param = new ParamsServices();

  edit = false;
  id: any = 0;
  info: ParamsDto = {};

  created() {
    this.id = this.$route.query.id;
  }

  @Watch('$route')
  onRouteChange() {
    this.id = this.$route.query.id;
    this.onIdChange();
  }

  @Watch('id')
  async onIdChange() {
    if (!this.id || this.$route.path != '/decision/params/detail') return false;
    this.spinning = true;
    this.info = await this.param.getInfo(this.id);
    this.spinning = false;
    this.getRefs();
  }

  refList: any = [];
  async getRefs() {
    let list = await this.param.getRefList({ paramCode_eq: this.info.paramCode });
    this.refList = list.map((v: any) => ({ ...v, edit: false }));
  }

  async saveRef(record: any, index: number) {
    await this.param.updateRef(record);
    this.refList[index].edit = false;
  }
}
